<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Pay Status

      <employee-profile-payroll-payroll-company-pay-status-dialog-edit
        v-if="$hasPermissionTo(['update employee payroll'])"
        :company-employee="companyEmployee"
        @updated="$emit('load')"
      />
    </h4>
    
    <span 
      v-if="isActivePayStatus === true" 
      class="font-weight-medium px-3 green--text"
    >
      ACTIVE
    </span>
    <span 
      v-else 
      class="font-weight-medium px-3 red--text"
    >
      INACTIVE
    </span>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyPayStatusDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/pay-status/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        isActivePayStatus: false,
      }
    },
    watch: {
      companyEmployee: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.setPayStatus()
          }
        },
      },
    },
    methods: {
      setPayStatus () {
        if (this.companyEmployee.is_active_pay_status === 1) {
          this.isActivePayStatus = true
        } else {
          this.isActivePayStatus = false
        }
        return this.isActivePayStatus
      },
    },
  }
</script>
